import { createFileRoute } from '@tanstack/react-router'
import ReturnPage from "../../core/ReturnPage.tsx";

export const Route = createFileRoute('/return/$subpage')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ReturnPage />
}
